import { connect } from "react-redux";
import ValidationLocation from "./validationLocation";
import { bindActionCreators } from "redux";
import {
  getSiteListing,
  siteLocationApproval,
} from "services/redux/installation/siteListing/action";

const mapStateToProps = (state) => ({
  siteListData: state.siteListingReducer.siteListData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteListing,
      siteLocationApproval,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ValidationLocation);
